import api from './api';

const weworkNonChannelWelcomeService = {
  list: async (params = {}) => {
    const res = await api.get('/wework/non-channel-welcome', { params });
    return res.data;
  },
  getById: async (id) => {
    const res = await api.get(`/wework/non-channel-welcome/${id}`);
    return res.data;
  },
  save: async (data) => {
    const res = await api.post('/wework/non-channel-welcome', data);
    return res.data;
  },
  remove: async (id) => {
    const res = await api.delete(`/wework/non-channel-welcome/${id}`);
    return res.data;
  }
};

export default weworkNonChannelWelcomeService;


